import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { Divider, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import StarIcon from "@mui/icons-material/StarBorder";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import FrequentlyAskedPackages from "./FrequentlyAskedPackages";
import Checkout from "./Checkout";
import { LoadingSvg } from "../../../utils/SvgIcons";
import { getSitePackagesListApi } from "../../../../../services/packagesApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import FreeByCode from "./FreeByCode";

const unitPriceDisplayValue = {
  rial: "ریال",
  toman: "تومان",
  thousandRials: "هزار ریال",
  thousandTomans: "هزار تومان",
  millionRials: "میلیون ریال",
  millionTomans: "میلیون تومان",
};
export default function SitePackages(props) {
  const [packagesList, setPackagesList] = useState([]);
  const [selectFree, setSelectFree] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState({
    seleted: false,
    productId: "",
    price: 0,
  });

  const hadleSelectFree = (value) => {
    setSelectFree(value);
  };
  useEffect(() => {
    getSitePackagesList();
  }, []);

  const calculatePrice = (unit, price) => {
    if (unit == "rial") return price;
    else if (unit == "toman") return price / 10;
    else if (unit == "thousandRials") return price / 1000;
    else if (unit == "thousandTomans") return price / 10000;
    else if (unit == "millionRials") return price / 1000000;
    else if (unit == "millionTomans") return price / 10000000;
  };
  const getSitePackagesList = async () => {
    let toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      const data = {};
      const response = await getSitePackagesListApi(data);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        const packageList = resData["data"]["data"];
        const packages = [];
        packageList.forEach((p) => {
          packages[p["positionPakcage"] - 1] = {
            id: p.packageId["_id"],
            displayName: p.packageId["displayName"],
            subDisplayName: p["subDisplayName"],
            realPrice: p.packageId["realPrice"],
            discountPercent: p.packageId["discountPercent"],
            price: p.packageId["price"],
            unitPriceDisplay: p.packageId["unitPriceDisplay"],
            features: p.packageId["features"],
            buttonText: p["buttonText"],
            buttonVariant: p["buttonVariant"],
            typeOfPackage: p["typeOfPackage"],
          };
        });
        setPackagesList(packages);
      } else {
        console.log("getSitePackagesListelde");

        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error(error);
    }
  };

  const selectProduct = (seleted, productId, price) => {
    setSelectedProduct({ seleted, productId, price });
  };
  return (
    <Grid container sx={{ height: "100vh" }}>
      {selectFree ? (
        <FreeByCode hadleSelectFree={hadleSelectFree} />
      ) : (
        <Box sx={{ width: "100%", px: 1 }}>
          {selectedProduct.seleted ? (
            <Checkout
              selectProduct={selectProduct}
              selectedProduct={selectedProduct}
            />
          ) : (
            <React.Fragment>
              <GlobalStyles
                styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
              />
              {packagesList.length > 0 ? (
                <>
                  <Container
                    disableGutters
                    maxWidth="sm"
                    component="main"
                    sx={{ pt: 0, pb: 6 }}
                  >
                    <Paper sx={{border:"double 5px",p:2,mt:1}}>
                      <Typography align="center" component="p">
                        توجه: کدهای تخفیف ارائه شده برای شروع سال 2025 را در کادر
                        <span style={{ color: "red" }}>{` کد معرف `}</span>
                        وارد کنید
                      </Typography>
                      <Typography align="center" sx={{ fontWeight: "bold" }}>
                        پس از پر شدن ظرفیت هر کد، کد غیر فعال خواهد شد(ظرفیت محدود)
                      </Typography>
                    </Paper>

                    {/* <Typography
                    component="h5"
                    variant="h5"
                    align="center"
                    color="text.primary"
                    gutterBottom
                  >
                    تخفیف ویژه
                  </Typography>
                  <Typography
                    variant="h6"
                    align="center"
                    color="text.secondary"
                    component="p"
                  >
                    {` بمناسبت افتتاح برنامه و ارایه اولین نسخه (Beta) `}

                    <span style={{ color: "red" }}>{` پکیج سالیانه `}</span>
                    <span>{` به مدت محدود با `}</span>
                    <span
                      style={{ color: "red" }}
                    >{` تخفیف ویژه 40 درصد `}</span>
                    <span>{` ارائه می گردد `}</span>
                  </Typography> */}
                  </Container>
                  <Container maxWidth="md" component="main">
                    <Grid container spacing={5} alignItems="flex-end">
                      {packagesList.map((onePackage, index) => (
                        <Grid
                          item
                          key={`${onePackage.displayName}-${index}`}
                          xs={12}
                          // sm={onePackage.displayName === 'Enterprise' ? 12 : 6}
                          md={4}
                        >
                          <Card
                            sx={{
                              boxShadow:
                                onePackage.typeOfPackage == "popular" ? 6 : 0,
                            }}
                          >
                            <CardHeader
                              title={onePackage.displayName}
                              subheader={onePackage.subDisplayName}
                              titleTypographyProps={{ align: "center" }}
                              action={
                                onePackage.typeOfPackage === "popular" ? (
                                  <StarIcon color="warning" />
                                ) : null
                              }
                              subheaderTypographyProps={{
                                align: "center",
                              }}
                              sx={{
                                backgroundColor: (theme) =>
                                  theme.palette.mode === "light"
                                    ? theme.palette.grey[200]
                                    : theme.palette.grey[700],
                              }}
                            />
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "baseline",
                                  mb: 1,
                                }}
                              >
                                <Typography
                                  component="h3"
                                  variant="inherit"
                                  color="error"
                                  sx={{
                                    textDecoration: "line-through",
                                    opacity:
                                      onePackage.discountPercent == 0 ? 0 : 1,
                                  }}
                                >
                                  {`${calculatePrice(
                                    onePackage.unitPriceDisplay,
                                    onePackage.realPrice
                                  )} ${
                                    unitPriceDisplayValue[
                                      onePackage.unitPriceDisplay
                                    ]
                                  }`}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "flex-start",
                                  mb: 2,
                                }}
                              >
                                <Typography
                                  component="h2"
                                  variant="h3"
                                  color="text.primary"
                                >
                                  {calculatePrice(
                                    onePackage.unitPriceDisplay,
                                    onePackage.price
                                  )}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    mb: 1,
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    color="text.secondary"
                                  >
                                    {
                                      unitPriceDisplayValue[
                                        onePackage.unitPriceDisplay
                                      ]
                                    }
                                  </Typography>
                                  <Typography
                                    component="h5"
                                    variant="inherit"
                                    color="#a33e37"
                                    sx={{
                                      opacity:
                                        onePackage.discountPercent == 0 ? 0 : 1,
                                    }}
                                  >
                                    {` %${onePackage.discountPercent} تخفیف`}
                                  </Typography>
                                </Box>
                              </Box>
                              <ul>
                                {onePackage.features.map((line) => (
                                  <Typography
                                    component="li"
                                    variant="subtitle1"
                                    align="center"
                                    key={line}
                                  >
                                    {line}
                                  </Typography>
                                ))}
                              </ul>
                            </CardContent>
                            <CardActions>
                              <Button
                                fullWidth
                                onClick={() => {
                                  selectProduct(
                                    true,
                                    onePackage.id,
                                    onePackage.price
                                  );
                                }}
                                variant={onePackage.buttonVariant}
                              >
                                {onePackage.buttonText}
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Container>
                  <Container
                    disableGutters
                    maxWidth="sm"
                    component="main"
                    sx={{ pt: 0, pb: 6 }}
                  >
                    <Paper
                      sx={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        sx={{
                          backgroundColor: (theme) =>
                            theme.palette.mode === "light"
                              ? theme.palette.grey[200]
                              : theme.palette.grey[700],
                          textAlign: "center",
                          fontSize: "25px",
                        }}
                      >
                        رایگان
                      </Typography>
                      <Typography sx={{ textAlign: "center" }}>
                        استفاده رایگان از برنامه (ویژه)
                      </Typography>
                      <Button
                        sx={{ margin: "5px",width:"120px",alignSelf:"center" }}
                        onClick={() => {
                          hadleSelectFree(true);
                        }}
                        variant="contained"
                      >
                        انتخاب
                      </Button>
                    </Paper>
                  </Container>
                </>
              ) : (
                <Box
                  sx={{
                    backgroundColor: "#001e6a",
                    m: 1,
                    px: 1,
                    py: 5,
                    color: "white",
                    borderRadius: 5,
                    textAlign: "center",
                  }}
                >
                  <LoadingSvg />
                  <Divider>لطفا تا بارگزاری اطلاعات صبر کنید </Divider>
                </Box>
              )}

              <Container
                maxWidth="md"
                component="footer"
                sx={{
                  // borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                  mt: 2,
                  py: [6, 1],
                }}
              >
                <FrequentlyAskedPackages />
                <Box sx={{ mt: 5 }} />
              </Container>
            </React.Fragment>
          )}
        </Box>
      )}
    </Grid>
  );
}
